import React, { useEffect, useState } from "react"
import { injectIntl } from "react-intl"
import { RouteComponentProps } from "react-router"
import { ImportEditProps } from "../../common/types/inventory"
import { isError } from "../../state/helpers/Error"
import IntlProps from "../../state/helpers/IntlProps"
import { ImportStockDto } from "../../state/inventory/imports/models"
import { Service } from "../../state/inventory/imports/service"
import ImportAdjustmentListing from "./AdjustmentListing"
import ImportInfoPage from "./ImportInfoPage"

const ImportEdit = (props: RouteComponentProps<ImportEditProps>&IntlProps) => {
    const importId = props.match.params.importId
    const [importElem, setImport] = useState<ImportStockDto|null>(null)

    useEffect(() => {
        Service.get(importId).then(res => {
            if (!isError(res)) {
                setImport(res)
            }
        })
    }, [])
    
    return <>
        {importElem &&
            <ImportInfoPage
                import={importElem}
            />
        }
        <ImportAdjustmentListing
            importId={importId}
        />
    </>
}

export default injectIntl(ImportEdit)


// WEBPACK FOOTER //
// ./src/product/import/ImportEditPage.tsx